import {RGBAFormat, RGBFormat, Texture, Loader} from 'three';

const blobToBase64 = async (blob) => {
  const promise = new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result;
      resolve(base64String);
    };
    reader.onError = (err) => {
      reject(err);
    };
    reader.readAsDataURL(blob);
  });
  return promise;
};

const loadImage = (src) => {
  const i = new Image()
  const p = new Promise((resolve, reject) => {
    i.addEventListener('load', () => {
      const j = document.createElement('img')
      j.src = i.src
      resolve(j)
    })
    i.addEventListener('error', (err) => reject(err))
  })
  i.src = src
  return p
}

class MyTextureLoader extends Loader {
  constructor(manager) {
    super(manager);
    this.requestHeader = {};
    this.crossOrigin = '';
  }

  setRequestHeader(value) {
    if (value) {
      this.requestHeader = value;
    }
    return this;
  }

  setCrossOrigin(value) {
    this.crossOrigin = value;
    return this;
  }

  load(url, onLoad, onProgress, onError) {
    const texture = new Texture();

    const isJPEG = url.search(/\.jpe?g($|\?)/i) > 0 || url.search(/^data\:image\/jpeg/) === 0;
    try {
      fetch(url, { method: 'GET', headers: this.requestHeader }).then(res => res.blob()).then(async (blob) => {
        const imageSrc = await blobToBase64(blob);
        const image = await loadImage(imageSrc)
        texture.image = image;
        texture.format = isJPEG ? RGBFormat : RGBAFormat;
        texture.needsUpdate = true;
    
        if (onLoad !== undefined) {
          onLoad(texture);
        }
      });
  
    } catch(err) {
      if (onError) {
        onError(err)
      }
      return null
    }
    return texture;
  }
}

export { MyTextureLoader };
